import {
  CloseButton,
  CloseText,
  IconContainer,
  Icon,
} from './styles';

const CloseModalButton = ({ onClick, text }) => (
  <CloseButton type="button" onClick={onClick}>
    {text ? <CloseText>Close item view</CloseText> : null}
    <IconContainer>
      <Icon className="icon-close-1" />
    </IconContainer>
  </CloseButton>
);

export default CloseModalButton;
